import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
    headers: {
        // Cors
        "Access-Control-Allow-Origin": `${process.env.REACT_APP_API_URL}`,
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
        "Content-Type": "application/json",
    }
});

axiosInstance.interceptors.request.use((config) => {
    const data = localStorage.getItem("userInfo");
    if(!data) return config;
    const jsonData = JSON.parse(data);
    if(!jsonData.token) return config

    config.headers.Authorization = `Bearer ${jsonData.token}`;
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default axiosInstance;